var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14160",
    "data-name": "Group 14160",
    transform: "translate(-25 -13.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    transform: "translate(25 13.271)",
    fill: "rgba(255,255,255,0)",
    stroke: "var(--theme-text)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    className: "notStroke",
    width: 33,
    height: 21,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.5,
    height: 19.5,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y2: 11,
    transform: "translate(34 18.271)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y2: 11,
    transform: "translate(39 18.271)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y2: 11,
    transform: "translate(44 18.271)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y2: 11,
    transform: "translate(49 18.271)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagDetails);
export default __webpack_public_path__ + "static/media/magDetails.df9b3a8d6247b6cd088c71c29bad6871.svg";
export { ForwardRef as ReactComponent };